import axios from '@/axios/axios';
import { directStatus } from "@/data/constances";

export default {
  namespaced: true,
  state: {
    directMatchingList: [],
    directMatchingReceiveList: [],
    selectedDirectMatching: {},
    selectedDirectMatchingReceive: {},
    modalPopup: {
      isModal: false,
      matchNapPopup: false,
      answerNapPopup: false,
      matchReadPopup: false,
      matchAcceptPopup: false,
      matchDenyPopup: false,
      receiveAcceptPopup: false,
      receiveDenyPopup: false,
      deletePopup: false,
    }
  },
  actions: {
    getDirectDetail(_, idx) {
      return axios
        .get('/api/matching/direct/get', {
          params: { idx },
        })
        .then((response) => {
          if (response.status == 200) {
            return Promise.resolve(response)
          }

          return Promise.reject(response.message)
        })
        .catch((error) => {
          console.log(error)
          return Promise.reject(error)
        })
    },
    getDirectMatchingDetail({ commit }, idx) {
      return axios
        .get('/api/matching/direct/get', {
          params: { idx },
        })
        .then((response) => {
          if (response.status == 200) {
            commit('setSelectedDirectMatching', response.data)
            commit('setSelectedDirectMatchingReceive', response.data)
            return Promise.resolve(response)
          } else {
            commit('setSelectedDirectMatching', {})
            commit('setSelectedDirectMatchingReceive', {})
          }

          return Promise.reject(response.message)
        })
        .catch((error) => {
          console.log(error)
          return Promise.reject(error)
        })
    },

    createDirectMatching(_, data) {
      const match = new URLSearchParams(data);
      return axios
        .post('/api/matching/direct/create?' + match)
        .then((response) => {
          if (response.status == 200) {
            return Promise.resolve(response)
          }

          return Promise.reject(response.message)
        })
        .catch((error) => {
          console.log(error)
          return Promise.reject(error)
        })
    },

    updateDirectMatching(_, data) {
      const match = new URLSearchParams(data);
      return axios
        .post(`/api/matching/direct/update?${match}`)
        .then((response) => {
          if (response.status == 200) {
            return Promise.resolve(response)
          }

          return Promise.reject(response.message)
        })
        .catch((error) => {
          console.log(error)
          return Promise.reject(error)
        })
    },
    approveDirectMatching({ dispatch }, data) {
      return dispatch('updateDirectMatching', {
        ...data,
        status: directStatus.APPROVED,
      })
    },
    denyDirectMatching({ dispatch }, data) {
      return dispatch('updateDirectMatching', {
        ...data,
        status: directStatus.REJECT,
      })
    },

    deleteDirectMatching(_, idx) {
      return axios
        .delete('/api/matching/direct/delete', {
          params: { requestId: idx },
        })
        .then((response) => {
          if (response.status == 200) {
            return Promise.resolve(response)
          }

          return Promise.reject(response.message)
        })
        .catch((error) => {
          console.log(error)
          return Promise.reject(error)
        })
    },

  },
  mutations: {
    setOpenModalPopup(state, type) {
      state.modalPopup = {
        isModal: true,
        matchNapPopup: false,
        answerNapPopup: false,
        matchReadPopup: false,
        matchAcceptPopup: false,
        matchDenyPopup: false,
        receiveAcceptPopup: false,
        receiveDenyPopup: false,
        deletePopup: false,
        [type]: true
      }
    },
    setHideModalPopup(state) {
      state.modalPopup = {
        isModal: false,
        matchNapPopup: false,
        answerNapPopup: false,
        matchReadPopup: false,
        matchAcceptPopup: false,
        matchDenyPopup: false,
        receiveAcceptPopup: false,
        receiveDenyPopup: false,
        deletePopup: false,
      }
    },
    replaceDirectMatchingItem(state, payload) {
      state.directMatchingList = state.directMatchingList.map((item) => item.idx === payload.idx ? payload : item)
    },
    setDirectMatchingList(state, payload) {
      state.directMatchingList = payload
    },
    setSelectedDirectMatching(state, payload) {
      state.selectedDirectMatching = payload
    },
    setDirectMatchingReceiveList(state, payload) {
      state.directMatchingReceiveList = payload
    },
    setSelectedDirectMatchingReceive(state, payload) {
      state.selectedDirectMatchingReceive = payload
    },
  },
};
